import * as type from '../../../actions/index.types'

export function SocietyProfileReducers(state = {
    loading: false,
    updateLoading: false,
    societyProfileData: null,
    error: null
}, action) {

    switch (action.type) {
        // Get Society Profile
        case type.GET_SOCIETY_PROFILE:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case type.GET_SOCIETY_PROFILE_SUCCESS: {
            return {
                ...state,
                error: null,
                loading: false,
                societyProfileData: action.payload,
            }
        }
        case type.GET_SOCIETY_PROFILE_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                loading: false,
            }

        // Update Society Profile
        case type.UPDATE_SOCIETY_PROFILE:
            return {
                ...state,
                updateLoading: true,
                error: null,
            }
        case type.UPDATE_SOCIETY_PROFILE_SUCCESS: {
            return {
                ...state,
                error: null,
                updateLoading: false,
                societyProfileData: action.payload,
            }
        }
        case type.UPDATE_SOCIETY_PROFILE_FAILURE:
            return {
                ...state,
                error: action?.message || 'Failed to update profile.',
                updateLoading: false,
            }

        // Clear Society Profile
        case type.CLEAR_SOCIETY_PROFILE:
            return {
                ...state,
                societyProfileData: null,
                error: null,
            }

        default:
            return state
    }
}
